export default "__VITE_ASSET__DtdU_x9P__"